import React from 'react'
import { useNavigate } from 'react-router-dom';

export default function PrintBarcode() {
  const navigate = useNavigate();

  function Singleitem() {
    navigate("/dashboard/warehouse/printscan/single-item");

  }
  function Multipleitem() {
    navigate("/dashboard/warehouse/printscan/assembly");

  }
  return (
    <div>
    <h2 className="font-Montserrat text-lg font-medium text-black">
    Print barcode for:
  </h2>
  <div className="flex-4">
  
    <div className="flex mt-8">
      <div className="bg-white shadow-lg border-cyan-100 border-1 space-x-24 ml-8 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat cursor-pointer" onClick={Singleitem}>
        <div className="flex flex-col items-center py-4 font-Montserrat">
          <div className="text-center  mt-4 ">
            <div className="text-center">
              <button className=" text-center rounded-full    text-lg font-bold  mx-2">
                {" "}
               
                Single Item
              </button>
            </div>
          </div>
          <div className='mt-8'>
          <svg width="122" height="132" viewBox="0 0 122 132" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M86.7235 98.274L84.837 99.3465V89.903L86.7235 88.8305V98.274ZM102.25 79.9865L100.369 81.059V90.5025L102.25 89.43V79.9865ZM121.5 38.1755V101.464L67.875 132L0.5 93.621V30.3325L54.2185 0L121.5 38.1755ZM45.347 17.644L94.968 46.123L104.318 41.0795L54.1965 12.6445L45.347 17.644ZM61 70.884L11.5 42.185V87.23L61 115.423V70.884ZM77.6155 55.4345L29.111 26.741L17.869 33.1595L66.599 61.4185L77.6155 55.4345ZM110.5 50.248L99.5 56.177V71.5L83 80.784V65.076L72 71.005V116.996L110.5 95.0785V50.248ZM83.5115 90.662L81.592 91.7565V101.178L83.5115 100.105V90.662ZM91.239 86.262L89.347 87.34V96.7835L91.239 95.7055V86.262ZM94.396 84.4635L92.5095 85.536V94.9795L94.396 93.907V84.4635ZM97.608 82.632L95.683 83.7265V93.17L97.608 92.0755V82.632Z" fill="#AD8762"/>
          </svg>
          </div>
        </div>
      </div>

      <div className="bg-white shadow-lg border-cyan-100 border-1 space-x-24 ml-32 rounded-lg hover:border-blue-200 hover:shadow-xl w-full align-middle font-Montserrat cursor-pointer" onClick={Multipleitem}>
        <div className="flex flex-col items-center py-4 font-Montserrat">
          <div className="text-center  mt-4 ">
            <div className="text-center">
            <button className=" text-center rounded-full    text-lg font-bold  mx-2">
            {" "}
           
            Multiple Items
          </button>
            </div>
          </div>
          <div className='mt-8 mb-2'>
          <svg width="106" height="152" viewBox="0 0 106 152" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_997_6425)">
          <path d="M82.4635 74.4276V102.04L58.9749 115.281L29.5117 98.6995V70.967L59.0231 87.7892L82.4635 74.4276ZM55.9635 88.8466L34.2817 76.3021V95.8157L55.9635 108.144V88.8466ZM77.6454 79.8347L72.8272 82.4301V88.8466L65.5999 92.9079V86.131L60.7817 88.7264V108.817L77.6454 99.2042V79.8347Z" fill="#AD8762"/>
          <path d="M82.2676 74.4223L105.997 61.1328V88.8413L82.4603 102.083C82.4603 92.8786 82.4603 83.7466 82.2676 74.5425V74.4223ZM101.179 66.3236L96.3608 68.895V75.5998L89.1335 79.6612V72.7881L84.3153 75.3836V95.474L101.179 85.8613V66.3236Z" fill="#AD8762"/>
          <path d="M29.5355 71.0668V98.7032L0 81.9291V54.2927L29.5355 71.0668ZM26.5 71.8839L4.81818 59.3634V79.0453L26.5 91.2534V71.8839Z" fill="#AD8762"/>
          <path d="M82.4635 46.7385V74.4229L58.9749 87.7845L29.5117 71.0345V43.302L53.0004 30.0605L82.4635 46.7385ZM49.1217 37.7507L70.8035 50.199L74.899 47.9881L53.0004 35.5638L49.1217 37.7507ZM55.9635 61.0133L34.2817 48.4928V68.1747L55.9635 80.4789V61.0133ZM63.1908 54.2604L42.0149 41.7399L37.1967 44.5276L58.5413 56.8798L63.1908 54.2604ZM77.6454 52.0014L72.8272 54.5968V61.3017L65.5999 65.339V58.49L60.7817 61.0854V81.1758L77.6454 71.5632V52.0014Z" fill="#AD8762"/>
          <path d="M106 33.5704V61.1347L82.4632 74.4242C82.4632 65.2201 82.4632 56.1121 82.2705 46.8839L53 30.0618L76.5368 16.7483L106 33.5704ZM72.61 24.4144L94.2918 36.8628L98.3873 34.6519L76.4405 22.2275L72.61 24.4144ZM86.7273 40.9241L65.4791 28.4036L60.6609 31.1913L81.9091 43.5436L86.7273 40.9241ZM101.182 38.6651L96.3636 41.2605V47.9894L89.1364 52.0507V45.1537L84.3182 47.725V67.8395L101.182 58.2269V38.6651Z" fill="#AD8762"/>
          <path d="M53 30.2352L29.5355 43.4285V71.0409L0 54.2908V26.6304L23.5368 13.365L53 30.2352ZM19.5859 20.983L41.2677 33.4314L45.3632 31.2205L23.4164 18.7961L19.5859 20.983ZM26.5 44.2456L4.81818 31.7011V51.383L26.5 63.7112V44.2456ZM33.7273 37.4927L12.4791 24.9482L7.54045 27.7599L28.9091 40.1122L33.7273 37.4927Z" fill="#AD8762"/>
          <path d="M52.7392 30.2301C43.1028 24.6308 33.2978 18.9593 23.541 13.408L47.0056 -0.0737305L76.541 16.7484L52.7392 30.1821V30.2301ZM43.1028 7.59236L64.7846 20.0167L68.8801 17.8298L46.9574 5.45354L43.1028 7.59236ZM57.2442 24.1021L35.996 11.5576L31.1778 14.3693L52.5224 26.6975L57.2442 24.1021Z" fill="#AD8762"/>
          <path d="M82.4635 102.04V129.7L58.9749 143.038L29.5117 126.36V98.6035L59.0231 115.426L82.4635 102.04ZM55.9635 116.339L34.2817 103.794V123.476L55.9635 135.804V116.339ZM77.6454 107.327L72.8272 109.898V116.603L65.5999 120.665V113.791L60.7817 116.387V136.477L77.6454 126.865V107.327Z" fill="#AD8762"/>
          <path d="M82.2676 102.157L105.997 88.8433V116.48L82.4603 129.697C82.4603 120.493 82.4603 111.361 82.2676 102.157ZM101.179 93.962L96.3608 96.5574V103.262L89.1335 107.324V100.451L84.3153 103.046V123.136L101.179 113.524V93.962Z" fill="#AD8762"/>
          <path d="M29.5355 98.7271V126.363L0 109.589V81.929L29.5355 98.7271ZM26.5 99.5441L4.81818 86.9996V106.682L26.5 119.01V99.5441Z" fill="#AD8762"/>
          <path d="M82.4635 129.696V138.66L58.9749 152.021L29.5117 135.344V126.356L59.0231 143.034L82.4635 129.696ZM55.9635 141.327L34.2817 129.047V132.46L55.9635 144.764V141.327ZM77.6454 132.436L60.7817 142.048L58.9749 143.082L60.7817 142.048V145.509L77.6454 135.896V132.436Z" fill="#AD8762"/>
          <path d="M84.314 128.67L105.996 116.438V125.425L82.459 138.667V129.727L84.314 128.67ZM101.178 119.177L84.314 128.67V132.106L101.178 122.493V119.177Z" fill="#AD8762"/>
          <path d="M29.5114 126.385V135.348L0 118.574V109.586L29.5114 126.385ZM26.5 124.63L4.81818 112.302V115.666L26.5 127.995V124.63Z" fill="#AD8762"/>
          </g>
          <defs>
          <clipPath id="clip0_997_6425">
          <rect width="106" height="152" fill="white"/>
          </clipPath>
          </defs>
          </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
    
    </div>
  )
}
